import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  violations: null,
  success: false,
  error: false
};

const UserAddSlice = createSlice({
  name: "UserAdd",
  initialState,
  reducers: {
    userAddSuccess(state, action) {
      state.success = true;
    },
    userAddError(state, action) {
      state.violations = action.payload;
      state.error = true;
    },
    userAddReset(state) {
      state.success = false;
      state.violations = null
      state.error = false
    },
  },
});

export const {
  userAddSuccess,
  userAddError,
  userAddReset,
} = UserAddSlice.actions

export default UserAddSlice.reducer;
